import AppRoute from "models/AppRoute"

const RolesAndPermissionsRoute = new AppRoute({
    route: "/roles-and-permissions",
    navbar: true,
    authRequired: true,
})

export default RolesAndPermissionsRoute
